import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05fb0f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Área da Empresa")
  ])
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = {
  key: 0,
  class: "row",
  id: "divHome"
}
const _hoisted_12 = { class: "col-md-2 col-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meu Cadastro", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-3" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "col-md-2 col-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Funcionários", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "col-md-2 col-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meus Boletos", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "col-md-2 col-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meus Contratos", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "col-md-2 col-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Alterar Senha", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-lock" }, null, -1))
const _hoisted_31 = { class: "col-md-2 col-6" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Sair", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow-1" }, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "row",
  id: "divMeusDados"
}
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Dados da Empresa", -1))
const _hoisted_40 = { class: "col-md-12 dados-empresa" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { key: 6 }
const _hoisted_48 = { key: 7 }
const _hoisted_49 = { key: 8 }
const _hoisted_50 = { key: 9 }
const _hoisted_51 = { key: 10 }
const _hoisted_52 = { key: 11 }
const _hoisted_53 = { class: "col-md-12 mt-3 d-grid gap-2 d-sm-block" }
const _hoisted_54 = {
  key: 2,
  class: "row",
  id: "divFuncionarios"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Funcionários")
], -1))
const _hoisted_56 = { class: "card mb-2" }
const _hoisted_57 = { class: "card-body" }
const _hoisted_58 = { class: "card-title" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-3 col-6" }
const _hoisted_61 = { class: "col-md-3 col-6" }
const _hoisted_62 = { class: "col-md-3 col-6" }
const _hoisted_63 = { class: "col-md-3 col-6" }
const _hoisted_64 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_65 = { class: "col-md-12 mt-3 d-grid gap-2 d-sm-block" }
const _hoisted_66 = {
  key: 3,
  class: "row",
  id: "divMeusContratos"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Meus Contratos")
], -1))
const _hoisted_68 = { class: "card" }
const _hoisted_69 = { class: "card-body" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = { class: "card-title" }
const _hoisted_73 = { class: "col-md-4" }
const _hoisted_74 = { class: "card-title" }
const _hoisted_75 = { class: "col-md-4" }
const _hoisted_76 = { class: "card-title" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-4 col-6" }
const _hoisted_79 = { class: "col-md-4 col-6" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-md-4" }
const _hoisted_82 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_83 = { class: "col-md-12 mt-3 d-grid gap-2 d-sm-block" }
const _hoisted_84 = {
  key: 4,
  class: "row",
  id: "divMeusBoletos"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Meus Boletos")
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "" }, "A Pagar")
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Pagas")
], -1))
const _hoisted_88 = { class: "col-md-12 mt-3 mb-3 d-grid gap-2 d-sm-block" }
const _hoisted_89 = {
  key: 5,
  class: "row mt-2 mb-2",
  id: "divParceiros"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Parceiros")
], -1))
const _hoisted_91 = { class: "col-md-3 mb-2" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }),
  /*#__PURE__*/_createTextVNode(" Pesquisar ")
], -1))
const _hoisted_93 = { class: "col-md-3 mb-2" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }),
  /*#__PURE__*/_createTextVNode(" Categoria ")
], -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "- Todas Categorias - ", -1))
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "col-md-3 mb-2" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-marker" }),
  /*#__PURE__*/_createTextVNode(" Cidade ")
], -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "- Todas Cidades - ", -1))
const _hoisted_100 = ["value"]
const _hoisted_101 = { class: "col-md-3" }
const _hoisted_102 = { class: "card mb-4" }
const _hoisted_103 = ["src"]
const _hoisted_104 = { class: "card-body" }
const _hoisted_105 = { class: "card-title fw-bold" }
const _hoisted_106 = { class: "card-text endereco mb-0" }
const _hoisted_107 = { class: "card-text cidade mb-0" }
const _hoisted_108 = {
  key: 0,
  class: "card-text desconto mb-0 fw-bold"
}
const _hoisted_109 = {
  key: 1,
  class: "card-text desconto mb-0 fw-bold mt-3"
}
const _hoisted_110 = {
  class: "card-text telefone mt-2 mb-3fw-bold",
  title: "Telefone"
}
const _hoisted_111 = { class: "text-center mt-2" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, " Nenhum parceiro encontrado. ", -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fw-bold fs-5" }, " Deseja realmente sair? ")
], -1))

import { reactive, onMounted } from "vue";

//services
import * as empresaService from "@/services/empresaService";

import { f2dec, fdata, fdataHora } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";

import Parcela from "../cliente/Parcela.vue";
import MsgBox from "@/components/MsgBox/Index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

//vue
const controle = reactive({
    dadosEmpresa: null as empresaService.DadosEmpresa | null,
    parceiros: [] as import("@/services/clienteService").Parceiro[],
    filtrosParceiros: {
        pesquisa: "",
        categoriaId: null as number | null,
        cidadeId: null as number | null,
        paginaAtual: 1,
        tamanhoPagina: 12
    } as empresaService.EmpresaParceirosFiltros,
    totalParceiros: 0,
    cidades: [] as import("@/services/clienteService").Cidade[],
    ver: "" as string,
    status: "" as string,
    erro: "" as string,
    janSair: false as boolean
});

onMounted(() => {
    buscarDadosEmpresa();
    buscarParceiros();
    buscarCidades();
});

function buscarDadosEmpresa() {
    controle.status = "Buscando dados da empresa...";
    empresaService.obterDados()
        .then((r) => {
            controle.status = "";
            controle.dadosEmpresa = r;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarParceiros() {
    controle.status = "Buscando parceiros...";

    if (controle.filtrosParceiros.cidadeId != null) {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 300;
    }
    else {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 16;
    }
    empresaService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function verTodosParceiros() {
    controle.filtrosParceiros.pesquisa = "";
    controle.filtrosParceiros.categoriaId = null;
    controle.filtrosParceiros.cidadeId = null;
    controle.filtrosParceiros.paginaAtual = 1;
    controle.filtrosParceiros.tamanhoPagina = 300;

    controle.status = "Buscando parceiros...";
    empresaService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarCidades() {
    controle.status = "Buscando cidades...";
    empresaService.obterCidades()
        .then((r) => {
            controle.status = "";
            controle.cidades = r;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function pergSair() {
    controle.janSair = true;
}

function sair() {
    controle.janSair = false;
    controle.status = "Saindo...";
    localStorage.removeItem("empresaUser");
    window.location.reload();
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, " Bem-vindo, " + _toDisplayString(controle.dadosEmpresa ? controle.dadosEmpresa.empresa.nome : 'Empresa') + "! ", 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (controle.erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true),
        (controle.erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (controle.ver == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (controle.ver = 'meusDados'))
            }, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (controle.ver = 'funcionarios'))
            }, _hoisted_19)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (controle.ver = 'meusBoletos'))
            }, _hoisted_23)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (controle.ver = 'meusContratos'))
            }, _hoisted_27)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_RouterLink, {
              class: "botao-menu",
              to: { name: 'EmpresaAlterarSenha' }
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (pergSair()))
            }, _hoisted_34)
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusDados')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", null, " Nome: " + _toDisplayString(controle.dadosEmpresa?.empresa.nome), 1),
                  _createElementVNode("div", null, " CNPJ: " + _toDisplayString(controle.dadosEmpresa?.empresa.cnpj), 1),
                  (controle.dadosEmpresa?.empresa.responsavel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Responsável: " + _toDisplayString(controle.dadosEmpresa?.empresa.responsavel), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.ie)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Inscrição Estadual: " + _toDisplayString(controle.dadosEmpresa?.empresa.ie), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.im)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Inscrição Municipal: " + _toDisplayString(controle.dadosEmpresa?.empresa.im), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Email: " + _toDisplayString(controle.dadosEmpresa?.empresa.email), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.telefone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Telefone: " + _toDisplayString(controle.dadosEmpresa?.empresa.telefone), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.celular)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Celular: " + _toDisplayString(controle.dadosEmpresa?.empresa.celular), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.logradouro)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Logradouro: " + _toDisplayString(controle.dadosEmpresa?.empresa.logradouro), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.numero)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Número: " + _toDisplayString(controle.dadosEmpresa?.empresa.numero), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.bairro)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, " Bairro: " + _toDisplayString(controle.dadosEmpresa?.empresa.bairro), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.complemento)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Complemento: " + _toDisplayString(controle.dadosEmpresa?.empresa.complemento), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.cidade)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, " Cidade: " + _toDisplayString(controle.dadosEmpresa?.empresa.cidade?.nome) + " - " + _toDisplayString(controle.dadosEmpresa?.empresa.cidade?.estado), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosEmpresa?.empresa.cep)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, " CEP: " + _toDisplayString(controle.dadosEmpresa?.empresa.cep), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'funcionarios')
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _hoisted_55,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosEmpresa?.funcionarios, (funcionario) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: funcionario.clienteId
            }, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("h5", _hoisted_58, _toDisplayString(funcionario.nome), 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, "CPF: " + _toDisplayString(funcionario.cpf), 1),
                    _createElementVNode("div", _hoisted_61, "Nascimento: " + _toDisplayString(_unref(fdata)(funcionario.dataNascimento)), 1),
                    _createElementVNode("div", _hoisted_62, "Plano: " + _toDisplayString(funcionario.planoNome), 1),
                    _createElementVNode("div", _hoisted_63, "Valor R$: " + _toDisplayString(_unref(f2dec)(funcionario.valor)), 1)
                  ])
                ])
              ])
            ]))
          }), 128)),
          (!controle.dadosEmpresa?.funcionarios || controle.dadosEmpresa?.funcionarios.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, " Nenhum funcionário vinculado. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusContratos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _hoisted_67,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosEmpresa?.contratos, (contrato) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: contrato.contratoId
            }, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("h5", _hoisted_72, "Contrato: " + _toDisplayString(contrato.contratoId), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("h5", _hoisted_74, "Plano: " + _toDisplayString(contrato.plano.nome), 1)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("h5", _hoisted_76, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge rounded-pill", contrato.statusId === 2 ? 'badge-soft-success' : 'badge-soft-warning'])
                        }, _toDisplayString(contrato.status.descricao), 3)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, " Inicio: " + _toDisplayString(_unref(fdata)(contrato.dataInicio)), 1),
                    _createElementVNode("div", _hoisted_79, " Fim: " + _toDisplayString(_unref(fdata)(contrato.dataFim)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, " Assinado em: " + _toDisplayString(_unref(fdataHora)(contrato.dataAssinatura)), 1)
                  ])
                ])
              ])
            ]))
          }), 128)),
          (!controle.dadosEmpresa?.contratos || controle.dadosEmpresa?.contratos.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, " Nenhum contrato encontrado. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusBoletos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
          _hoisted_85,
          _hoisted_86,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosEmpresa?.mensalidades.filter(a=> a.dataPagamento == null), (parcela) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: parcela.mensalidadeId
            }, [
              _createVNode(Parcela, { parcela: parcela }, null, 8, ["parcela"])
            ]))
          }), 128)),
          _hoisted_87,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosEmpresa?.mensalidades?.filter(a=> a.dataPagamento != null), (parcela) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: parcela.mensalidadeId
            }, [
              _createVNode(Parcela, { parcela: parcela }, null, 8, ["parcela"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
          _hoisted_90,
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _withDirectives(_createElementVNode("input", {
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((controle.filtrosParceiros.pesquisa) = $event)),
              onInput: _cache[10] || (_cache[10] = ($event: any) => (buscarParceiros())),
              placeholder: "Nome do parceiro"
            }, null, 544), [
              [_vModelText, controle.filtrosParceiros.pesquisa]
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((controle.filtrosParceiros.categoriaId) = $event)),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (buscarParceiros()))
            }, [
              _hoisted_95,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosEmpresa?.categorias, (categoria) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: categoria.categoriaId,
                  value: categoria.categoriaId
                }, _toDisplayString(categoria.descricao), 9, _hoisted_96))
              }), 128))
            ], 544), [
              [_vModelSelect, controle.filtrosParceiros.categoriaId]
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _hoisted_98,
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((controle.filtrosParceiros.cidadeId) = $event)),
              onChange: _cache[14] || (_cache[14] = ($event: any) => (buscarParceiros()))
            }, [
              _hoisted_99,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.cidades, (cidade) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cidade.cidadeId,
                  value: cidade.cidadeId
                }, _toDisplayString(cidade.nome) + " - " + _toDisplayString(cidade.estado), 9, _hoisted_100))
              }), 128))
            ], 544), [
              [_vModelSelect, controle.filtrosParceiros.cidadeId]
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("a", {
              class: "btn btn-primary btn-sm mb-2 mt-4",
              href: "javascript:void(0);",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (verTodosParceiros()))
            }, " Ver todos ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.parceiros, (parceiro) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-3",
              key: parceiro.parceiroId
            }, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("img", {
                  src: `${parceiro.arquivo}`,
                  class: "card-img-top",
                  alt: "..."
                }, null, 8, _hoisted_103),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("h6", _hoisted_105, _toDisplayString(parceiro.nome), 1),
                  _createElementVNode("div", _hoisted_106, _toDisplayString(parceiro.logradouro != null ? parceiro.logradouro + ' ' +
                        parceiro.numero + ' - ' : '') + " " + _toDisplayString(parceiro.bairro), 1),
                  _createElementVNode("div", _hoisted_107, _toDisplayString(parceiro.cidade?.nome) + "/" + _toDisplayString(parceiro.cidade?.estado), 1),
                  (parceiro.valorDescontoIni != null && parceiro.valorDescontoIni > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, " Desconto: de " + _toDisplayString(parceiro.valorDescontoIni) + " % até " + _toDisplayString(_unref(f2dec)(parceiro.valorDesconto)) + " % ", 1))
                    : _createCommentVNode("", true),
                  (parceiro.valorDescontoIni == null || parceiro.valorDescontoIni == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, " Desconto: " + _toDisplayString(_unref(f2dec)(parceiro.valorDesconto)) + " % ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_110, "Telefone: " + _toDisplayString(parceiro.telefone), 1),
                  _createElementVNode("div", _hoisted_111, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'PainelClienteParceiro', params: { parceiroId: parceiro.parceiroId } },
                      class: "btn btn-primary btn-sm text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ver detalhes")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ])
            ]))
          }), 128)),
          (controle.parceiros.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(MsgBox, {
      id: 'janSair',
      titulo: 'Atenção',
      exibir: controle.janSair,
      onOnFechou: _cache[16] || (_cache[16] = ($event: any) => (controle.janSair = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[17] || (_cache[17] = ($event: any) => (sair()))
    }, {
      default: _withCtx(() => [
        _hoisted_115
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})